/* unplugin-vue-components disabled */import { render } from "./RealFaceGuide.vue?vue&type=template&id=5aa0784c&scoped=true"
import script from "./RealFaceGuide.vue?vue&type=script&lang=js"
export * from "./RealFaceGuide.vue?vue&type=script&lang=js"

import "./RealFaceGuide.vue?vue&type=style&index=0&id=5aa0784c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa0784c"]])

export default __exports__